export default __webpack_public_path__ + "static/media/food_art.d758e788.png";